import { useParams } from 'react-router-dom'

const AccessDeniedElement = function () {

	const { beId } = useParams()

	return (
		<div className='panel'>
			<div className='panel-body'>
				<div className='block'>
					<div className='centered'>
						<div>
							You do not have access to this area.&nbsp;
							<a href={`./#/be/${beId}/profile`} className='btn-link'>Get me out of here!</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
export default AccessDeniedElement